import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { kabobToUpperCase, formatNumber } from '../../../../utils/helpers';
import { regionData } from './../helpers/regionData';

import './Info.css';

const Info = ({ property: {
    region,
    submarket,
    in_service,
    development,
    redevelopment,
    repositioning,
    rba,
    slug,
    spaces,
    browse_availabilities_link
}, filters }) => {

    const filteRegion = regionData.find(item => item.value === region);

    return (
        <div className="info-wrapper">
            <div className="info-text-wrapper">
                <div className="info-text info-title info-bold-2">REGION</div>
                <div className={`info-text info-desc ${filters.region === null ? '' : 'active'}`}>
                    {filteRegion.label}
                </div>
            </div>

            <div className="info-text-wrapper">
                <div className="info-text info-title info-bold-2">SUBMARKET</div>
                <div className={`info-text info-desc ${filters.subMarket === null ? '' : 'active'}`}>
                    {kabobToUpperCase(submarket)}
                </div>
            </div>

            <div className="info-text-wrapper">
                <div className="info-text info-title info-bold-2">TYPE</div>
                <div className={`info-text info-desc ${filters.projectType === null ? '' : 'active'}`}>
                    {in_service && <div>IN-SERVICE<br /></div>}
                    {development && <div>DEVELOPMENT<br /></div>}
                    {redevelopment && <div>REDEVELOPMENT<br /></div>}
                    {repositioning && <div>REPOSITIONING<br /></div>}
                </div>
            </div>

            <div className="info-text-wrapper">
                <div className="info-text info-title info-bold-2">TOTAL SQ FT</div>
                <div className={`info-text info-desc ${filters.totalSqFt === null ? '' : 'active'}`}>
                    {formatNumber(rba)}
                </div>
            </div>

            {/* {browse_availabilities_link
                ? <a href={`${browse_availabilities_link}`} className="availability" target='_blank'>Availabilities</a>
                : <div className="availability inactive">Fully Leased</div>} */}
        </div>);
};

Info.propTypes = {
    filters: PropTypes.object,
    property: PropTypes.shape({
        region: PropTypes.string.isRequired,
        submarket: PropTypes.string, //.isRequired, // TODO: some properties missing this, require when api is updated
        in_service: PropTypes.bool.isRequired,
        development: PropTypes.bool.isRequired,
        redevelopment: PropTypes.bool.isRequired,
        repositioning: PropTypes.bool.isRequired,
        rba: PropTypes.number,
        slug: PropTypes.string.isRequired,
        spaces: PropTypes.arrayOf(PropTypes.object),
        browse_availabilities_link: PropTypes.string,
    }).isRequired,
};

export default Info;
